"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports.mapDispatchToProps = exports["default"] = exports.DataRequestForm = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseReducers = require("nicbase-reducers");

var _nicbaseTranslation = require("nicbase-translation");

var _dataRequestError = _interopRequireDefault(require("./data-request-error"));

var _tourDetails = _interopRequireDefault(require("./tour-details"));

var _dataRequestFormModule = _interopRequireDefault(require("./data-request-form.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var mapStateToProps = function mapStateToProps(state) {
  return {
    dataRequest: state.dataRequest,
    linkedPortals: state.informationLists.linkedPortals,
    assets: state.assetInformationLists.assets
  };
};

exports.mapStateToProps = mapStateToProps;

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var tourId = ownProps.tourId,
      portalId = ownProps.portalId;
  return {
    portalLoginRequest: function portalLoginRequest() {
      dispatch((0, _nicbaseReducers.changeActivePortal)(portalId));
      dispatch((0, _nicbaseReducers.getAssetInformationList)(portalId));
    },
    getLinkedPortals: function getLinkedPortals() {
      return dispatch((0, _nicbaseReducers.getLinkedPortalsInformationListFromBackend)(portalId));
    },
    getTour: function getTour() {
      return dispatch((0, _nicbaseReducers.findTourForDataRequest)(tourId, portalId));
    },
    assignAsset: function assignAsset(assetId, assetType) {
      return dispatch((0, _nicbaseReducers.assignAssetToTour)(tourId, assetId, assetType, portalId));
    }
  };
};

exports.mapDispatchToProps = mapDispatchToProps;

var DataRequestForm = /*#__PURE__*/function (_Component) {
  _inherits(DataRequestForm, _Component);

  var _super = _createSuper(DataRequestForm);

  function DataRequestForm(props) {
    var _this;

    _classCallCheck(this, DataRequestForm);

    _this = _super.call(this, props);
    _this.state = {
      selectedAsset: null,
      showConfirmPage: false
    };
    _this.assignAsset = _this.assignAsset.bind(_assertThisInitialized(_this));
    _this.changeAsset = _this.changeAsset.bind(_assertThisInitialized(_this));
    _this.renderForm = _this.renderForm.bind(_assertThisInitialized(_this));
    _this.renderFooter = _this.renderFooter.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DataRequestForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          getTour = _this$props.getTour,
          portalLoginRequest = _this$props.portalLoginRequest,
          getLinkedPortals = _this$props.getLinkedPortals;
      getTour();
      portalLoginRequest();
      getLinkedPortals();
    }
  }, {
    key: "assignAsset",
    value: function assignAsset() {
      var _this$props2 = this.props,
          assignAsset = _this$props2.assignAsset,
          assets = _this$props2.assets;
      var selectedAsset = this.state.selectedAsset;

      var _ref = assets.find(function (asset) {
        return asset.id === selectedAsset;
      }) || {},
          id = _ref.id,
          type = _ref.type;

      assignAsset(id, type);
      this.setState({
        showConfirmPage: true
      });
    }
  }, {
    key: "changeAsset",
    value: function changeAsset(selectedAsset) {
      this.setState({
        selectedAsset: selectedAsset
      });
    }
  }, {
    key: "renderForm",
    value: function renderForm() {
      var assets = this.props.assets;
      var selectedAsset = this.state.selectedAsset;
      var assetSource = assets.reduce(function (result, asset) {
        result[asset.id] = asset.name;
        return result;
      }, {});
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _dataRequestFormModule["default"].assignmentForm
      }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
        id: "requestForData.selectionHint"
      }, function (message) {
        return /*#__PURE__*/_react["default"].createElement("span", {
          className: _dataRequestFormModule["default"].selectionHint
        }, message);
      }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiAutocomplete, {
        className: _dataRequestFormModule["default"].assetSelection,
        label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
          id: "requestForData.selectAsset",
          tagName: "span"
        }),
        disabled: assets.length === 0,
        value: selectedAsset,
        source: assetSource,
        valueType: "Integer",
        onChange: this.changeAsset
      }));
    }
  }, {
    key: "renderFooter",
    value: function renderFooter() {
      var selectedAsset = this.state.selectedAsset;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _dataRequestFormModule["default"].footer
      }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiButton, {
        primary: true,
        raised: true,
        disabled: !selectedAsset,
        onClick: this.assignAsset
      }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
        id: "requestForData.confirm",
        tagName: "span"
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          assets = _this$props3.assets,
          dataRequest = _this$props3.dataRequest,
          portalId = _this$props3.portalId,
          linkedPortals = _this$props3.linkedPortals;
      var tour = dataRequest.tour;
      var _this$state = this.state,
          showConfirmPage = _this$state.showConfirmPage,
          selectedAsset = _this$state.selectedAsset;

      var _ref2 = assets.find(function (asset) {
        return asset.id === selectedAsset;
      }) || {
        name: 'no asset found'
      },
          assetName = _ref2.name;

      var _ref3 = tour || {
        name: 'no tour found'
      },
          tourName = _ref3.name,
          owningPortalId = _ref3.owningPortalId;

      var owner = linkedPortals[owningPortalId] || {};

      if (dataRequest.hasError) {
        return /*#__PURE__*/_react["default"].createElement(_dataRequestError["default"], null);
      }

      if (showConfirmPage) {
        return [/*#__PURE__*/_react["default"].createElement("div", {
          className: _dataRequestFormModule["default"].spacer
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: _dataRequestFormModule["default"].confirmationContainer
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _dataRequestFormModule["default"].confirmTitle
        }, "Assetanfrage"), /*#__PURE__*/_react["default"].createElement("div", {
          className: _dataRequestFormModule["default"].contentContainer
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _dataRequestFormModule["default"].tick
        }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.CheckOkSolid, null)), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
          id: "requestForData.assetSuccessfullyTransferred"
        }, function (text) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: _dataRequestFormModule["default"].subtitle
          }, text);
        }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
          id: "requestForData.assetAssignedToTour",
          values: {
            assetName: assetName,
            tourName: tourName
          }
        }, function (text) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: _dataRequestFormModule["default"].info1
          }, text);
        }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
          id: "requestForData.assetDataWillBeShared",
          values: {
            portalName: owner.name
          }
        }, function (text) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: _dataRequestFormModule["default"].info2
          }, text);
        }))), /*#__PURE__*/_react["default"].createElement("div", {
          className: _dataRequestFormModule["default"].spacer
        })];
      }

      if (assets.length === 0 || dataRequest.isLoading) {
        return /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.NicbaseSpinnerComponent, null);
      }

      var isTourRunning = tour.status !== 'WAITING';
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _dataRequestFormModule["default"].assetAssignment
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _dataRequestFormModule["default"].header
      }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
        id: "requestForData.header",
        tagName: "span"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _dataRequestFormModule["default"].content
      }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
        id: !isTourRunning ? 'requestForData.assignAsset' : 'requestForData.tourIsRunning'
      }, function (title) {
        return /*#__PURE__*/_react["default"].createElement("h2", {
          className: _dataRequestFormModule["default"].title
        }, title);
      }), /*#__PURE__*/_react["default"].createElement(_tourDetails["default"], {
        tour: tour,
        portalId: portalId
      }), !isTourRunning && this.renderForm()), !isTourRunning && this.renderFooter());
    }
  }]);

  return DataRequestForm;
}(_react.Component);

exports.DataRequestForm = DataRequestForm;
DataRequestForm.propTypes = {
  dataRequest: _propTypes["default"].shape({
    tour: _propTypes["default"].shape({
      status: _propTypes["default"].string
    }),
    hasError: _propTypes["default"].bool,
    isLoading: _propTypes["default"].bool
  }),
  portalId: _propTypes["default"].number,
  assets: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  linkedPortals: _propTypes["default"].shape({}),
  getLinkedPortals: _propTypes["default"].func,
  portalLoginRequest: _propTypes["default"].func,
  getTour: _propTypes["default"].func,
  assignAsset: _propTypes["default"].func
};

var noop = function noop() {};

DataRequestForm.defaultProps = {
  assets: [],
  linkedPortals: {},
  portalId: null,
  dataRequest: {
    tour: {
      tourBegin: {},
      tourEnd: {}
    }
  },
  getLinkedPortals: noop,
  portalLoginRequest: noop,
  getTour: noop,
  assignAsset: noop
};

var _default = (0, _nicbaseTranslation.injectIntl)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DataRequestForm));

exports["default"] = _default;